// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"vv_a bhe_b bhe_ux"};